import { Injectable, EventEmitter, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiService } from './../_services/api.service';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AnpiService {
  
  private anpiCode: string | null = null;
  bankDetails:any;
  response: any;
  accountDetails: any;
  changeEvent: EventEmitter<any> = new EventEmitter<any>();
  accountEvent: EventEmitter<any> = new EventEmitter<any>();
  faqEvent: EventEmitter<any> = new EventEmitter<any>();
  private accountEventSource = new Subject<any>();
  accountEvent$ = this.accountEventSource.asObservable();

  constructor(private zone: NgZone,
              private api: ApiService) {}

  setAnpiCode(code: string): void {
    this.anpiCode = code;
    console.log("your anpiCode is :",code)
    console.log("your anpiCode is :",this.anpiCode)
  }

  getAnpiCode(): string | null {
    return this.anpiCode;
  }
  emitEvent() {
    console.log('emitEvent has called')
    this.changeEvent.emit();
  }
  emitAccountEvent1() {
    console.log('emitAccountEvent1 has called')
    this.zone.run(() => {
    setTimeout(() => {
      console.log('emitAccountEvent1 has called')
      this.accountEventSource.next();
    },1000)
  });
  }

  emitAccountEvent(){
    console.log('accountEvent has called')
    this.zone.run(() => {
      setTimeout(() => {
        this.accountEvent.emit();
      },100)
    });
  }
   faqChangEvent(){
    console.log('faqChangEvent has called')
    this.faqEvent.emit();
  }


  getAccountData() {
    console.log("442 get employer details")
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
          this.response = res.results;
          if (res.status == 200) {
            console.log("88", res)
            this.accountDetails = this.response;
            // this.accountDetails['BankDetails'] = 1;
            const data = JSON.stringify(this.accountDetails);
            localStorage.setItem('currentUserDetails', data);
             this.emitEvent();
          }
        },
        error => {
        });
  }



}